import { render, staticRenderFns } from "./LastWorkOrder.vue?vue&type=template&id=58da1243&scoped=true"
import script from "./LastWorkOrder.vue?vue&type=script&lang=js"
export * from "./LastWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./LastWorkOrder.vue?vue&type=style&index=0&id=58da1243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58da1243",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
